import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task03 } from "../../../../../task/course-04/lesson-14/task-03";

const task: Slide = {
  titleHtml:
    "The directvity pattern of a unidirectionnal microphone of order 1 is given below. Calculate the<br>value of the pattern coefficient ß  corresponding to the above plot.",
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/14/task/task-3.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task03.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
